import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Box,
  Paper,
  Avatar,
  useMediaQuery,
  useTheme,
  Chip
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import InventoryIcon from "@mui/icons-material/Inventory";

interface StockReceiptItem {
  variant_id: number;
  stock_type: "in_store" | "online";
  quantity: number;
  unit_cost: number;
  sku?: string;
  variant_name?: string;
  product_name?: string;
  image_url?: string;
}

interface Props {
  items: StockReceiptItem[];
  setItems: React.Dispatch<React.SetStateAction<StockReceiptItem[]>>;
}

const ReceivingTable = ({ items, setItems }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDelete = (index: number) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  if (items.length === 0) return null;

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Items to Receive ({items.length})
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size={isMobile ? "small" : "medium"}>
          <TableHead>
            <TableRow sx={{ backgroundColor: theme.palette.grey[100] }}>
              {!isMobile && <TableCell>Image</TableCell>}
              <TableCell>{isMobile ? "Name" : "Product/Variant"}</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell align="right">Cost</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell align="right">Type</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={index}>
                {!isMobile && (
                  <TableCell>
                    <Avatar 
                      src={item.image_url} 
                      variant="rounded" 
                      sx={{ width: 40, height: 40 }} 
                    />
                  </TableCell>
                )}
                <TableCell>
                  <Box>
                    {!isMobile && (
                      <Typography variant="subtitle2">{item.product_name}</Typography>
                    )}
                    <Typography variant="body2">{item.variant_name}</Typography>
                    {isMobile && (
                      <Typography variant="caption" color="text.secondary">
                        SKU: {item.sku}
                      </Typography>
                    )}
                  </Box>
                </TableCell>
                <TableCell align="right">{item.quantity}</TableCell>
                <TableCell align="right">${item.unit_cost}</TableCell>
                <TableCell align="right">${(item.unit_cost * item.quantity).toFixed(2)}</TableCell>
                <TableCell align="right">
                  <Chip 
                    label={item.stock_type} 
                    size="small" 
                    color={item.stock_type === "in_store" ? "primary" : "secondary"}
                  />
                </TableCell>
                <TableCell align="right">
                  <IconButton 
                    onClick={() => handleDelete(index)} 
                    size="small"
                    color="error"
                  >
                    <DeleteIcon fontSize={isMobile ? "small" : "medium"} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ReceivingTable;